export default "__VITE_ASSET__DjmtOwp5__"